import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MdDoubleArrow, MdSentimentVeryDissatisfied } from "react-icons/md";
import FavouriteCard from "./FavouriteCard";
import Background from "../CarList/Background";
import img from "../../assets/favourite-bg.avif";
import { getFavcars } from "../../redux/Slice/configSlice";
import { Pagination } from "@mui/material";
import { toast } from "react-toastify";
import noData from "../../assets/no-data.png";
const Index = () => {
  const dispatch = useDispatch();
  const userDetail = useSelector((state) => state?.auth?.userDetail);
  const { getFavcarsData, favUnFavStatus, favUnFavDetail } = useSelector(
    (state) => state?.config
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(6);

  useEffect(() => {
    if (userDetail?.data?._id) {
      dispatch(getFavcars({ signInId: userDetail?.data?._id }));
    }
  }, [dispatch, userDetail?.data?._id]);

  useEffect(() => {
    // Ensure current page is valid after data changes
    const totalPages = Math.ceil(getFavcarsData?.length / itemsPerPage);
    if (currentPage > totalPages && totalPages > 0) {
      setCurrentPage(totalPages);
    } else if (totalPages === 0) {
      setCurrentPage(1);
    }
  }, [getFavcarsData, currentPage, itemsPerPage]);
  useEffect(() => {
    if (favUnFavStatus === "fulfilled" && favUnFavDetail?.success === true) {
      toast(favUnFavDetail?.message);
    }
  }, [favUnFavDetail]);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = getFavcarsData?.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  return (
    <div className="container-fluid pb-6 px-0">
      <Background image={img} name="Favourites" />
      <div className="container">
        <div className="d-flex flex-row fs-2 accentColor align-items-center py-2 mb-3">
          <span className="lh-0">
            <MdDoubleArrow />
          </span>
          <span className="font">Favourites</span>
        </div>
        <div className="row">
          {currentItems && currentItems.length > 0 ? (
            currentItems.map((data) => (
              <div
                key={data?.carId?._id}
                className="col-md-6 col-lg-4 m-0 pb-4"
              >
                <FavouriteCard
                  carId={data?.carId?._id}
                  carImage={data?.carId?.frontImage}
                  carName={data?.carId?.maker?.carMake}
                  carSeat={data?.carId?.numberOfSeats}
                  carPower={data?.carId?.power}
                  carSpeed={data?.carId?.topSpeed}
                  carMotor={data?.carId?.motor}
                  carPrice={data?.carId?.pricePerDay}
                  isUserFavId={data?.carId?.isUserFavId}
                  rating={data?.carId?.averageRating}
                />
              </div>
            ))
          ) : (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ minHeight: "200px" }}
            >
              <img src={noData} alt="no data found" className="nofoundImg" />

              {/* <MdSentimentVeryDissatisfied
                style={{ fontSize: "48px", marginRight: "10px" }}
              />
              <p className="accentColor">No favorite cars yet.</p> */}
            </div>
          )}
        </div>
      </div>
      <div className="mt-4 text-end">
        {getFavcarsData?.length > 0 && (
          <Pagination
            count={Math.ceil(getFavcarsData?.length / itemsPerPage)}
            page={currentPage}
            shape="rounded"
            onChange={handlePageChange}
          />
        )}
      </div>
    </div>
  );
};

export default Index;
